export const escapeHtml = (unsafe = '') => {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

export const sanitizeTextForRender = (text = '') => {
  if (!text) return '';

  return text
    .replace(/\n/g, '<br>')
    .split(/(<\/?\w+(?:\s+[^>]*)?\/?>)/g)
    .map((segment, index) =>
      index % 2 === 0
        ? segment.replace(/</g, '&lt;').replace(/>/g, '&gt;')
        : segment
    )
    .join('');
};

export const afterSanitizeAttributes = currentNode => {
  if ('target' in currentNode) {
    currentNode.setAttribute('target', '_blank');
  }
};

export const domPurifyConfig = {
  hooks: {
    afterSanitizeAttributes,
  },
};
